import React from "react";
import TriloChatStudySelector from "./TriloChatStudySelector";
import { ChatIcon } from "./TriloChatIcons";
import { NO_PERMISSION_TITLE } from "../utils/permissions";

/**
 * TriloChatWelcome
 *
 * Shown when no conversation is open: what MW can answer, an optional study
 * context to start in, and the button that opens the first session.
 *
 * Props:
 * - studies: Array of { id, name }
 * - selectedStudyId: Pre-selected study context, or ""
 * - onStudyChange: (studyId: string) => void
 * - onStart: () => void
 * - disabled: Whether the user may not start conversations
 * - disabledTitle: Why it is disabled, shown on hover while disabled
 */
const TriloChatWelcome = ({
  studies,
  selectedStudyId,
  onStudyChange,
  onStart,
  disabled,
  disabledTitle = NO_PERMISSION_TITLE,
}) => (
  <div className="trilochat__no-session">
    <ChatIcon />
    <h3>Ask MW anything</h3>
    <p>
      Ask about your study data, section outputs, protocol deviations,
      demographics, efficacy results, or Patient Narratives. MW uses your real
      study data to answer.
    </p>
    <TriloChatStudySelector
      label="Study context"
      studies={studies}
      selectedStudyId={selectedStudyId}
      onChange={onStudyChange}
    />
    <button
      onClick={onStart}
      disabled={disabled}
      title={disabled ? disabledTitle : undefined}>
      Start a conversation
    </button>
  </div>
);

export default TriloChatWelcome;
